module.exports = __webpack_public_path__ + "img/elections-2025-img-1.916eef78.webp";